import Mask from "common/widgets/DFMaskedInput/Mask";
import BaseWidget from "common/widgets/base/BaseWidget";
import classes from "app/css/widgets/DFMaskedInput.module.less";
import "common/bindings/field";

/**
 * This defines a special masked input that matches the syntax DocFinity requires.
 *
 * This should only be used if user provided mask formats need to be used.
 *
 * This SHOULD NOT be used instead of the standard Kendo MaskedTextBox if the mask format is programmer defined.
 */
var DFMaskedInput = BaseWidget(kendo.ui.MaskedTextBox).extend({
    options: {
        name: "DFMaskedInput",
        rules: {
            l: /[a-z]/,
            u: /[A-Z]/,
            '*': /./
        }
    },

    events: [
        // fired when the value fulfills the mask
        "fulfilled"
    ],

    init: function() {
        kendo.ui.MaskedTextBox.fn.init.apply(this, arguments);
        this.wrapper.addClass(classes.DFMaskedInput);
    },

    mask: function(input) {
        if (input !== undefined) {
            var mask = new Mask(input);
            var kendo = mask.toKendo();

            //mask is not allowed to contain promptChar
            //if it does, fallback to a rarely used double-underscore. In arial, this looks just like an underscore
            var promptChar = "_";
            if (kendo.indexOf(promptChar) >= 0) {
                promptChar = '\u2017';
            }

            this.setOptions({
                mask: kendo,
                promptChar: promptChar
            });
        }
    },

    focus: function() {
        this.element.focus();
    },

    /**
     * Override
     * Process the mask input for fulfillment after kendo sets the value appropriately
     */
    inputChange: function() {
        kendo.ui.MaskedTextBox.fn.inputChange.apply(this, arguments);
        if(this.raw().length === this.tokens.length) {
            this._fulfilled();
        }
    },

    /**
     * The mask is fulfilled
     * @private
     */
    _fulfilled: function() {
        this.trigger("fulfilled");
    }
});

kendo.ui.plugin(DFMaskedInput);
export default DFMaskedInput;
